import { render } from "./chooseWallet.vue?vue&type=template&id=acb2afbe&scoped=true&lang=pug"
import script from "./chooseWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseWallet.vue?vue&type=script&setup=true&lang=js"

import "./chooseWallet.vue?vue&type=style&index=0&id=acb2afbe&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb2afbe"]])

export default __exports__